import fetch from 'isomorphic-fetch';
import {DOCUMENTS_TYPES_REQUEST, DOCUMENTS_TYPES, DOCUMENTS_TYPES_FAIL, API2_URL} from "../store/config";
import { newNotification } from "./notifications";
import {sessionService} from "redux-react-session";
import _ from 'lodash';

export const documentsTypesShow = () => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			dispatch(documentsTypesRequest());
			return fetch(`${API2_URL}/documents/types?per_page=all`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(documentsTypesData(json)),
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(documentsTypesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

const documentsTypesData = (json) => {
	return {
		type: DOCUMENTS_TYPES,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const documentsTypesRequest = () => {
	return {
		type: DOCUMENTS_TYPES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const documentsTypesFail = (error) => {
	return {
		type: DOCUMENTS_TYPES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}



// WEBPACK FOOTER //
// ./src/actions/documents_types.js